// Libs
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
// Components, Layouts, Pages
import { MainLayout } from './layouts';
import { ProtectedRoute, NotFoundPage } from '~/components/common';
// Others
import { authRoute } from '~/utils/routes/auth';
import { publicRoutes } from '~/utils/routes';
import { adminRoute, privateAdminRoutes } from '~/utils/routes/admin';
import { privateStaffRoutes, staffRoute } from '~/utils/routes/staff';
import { RoleEnum } from '~/utils/enum/common';

const App = () => {
  return (
    <BrowserRouter>
      <ToastContainer />

      <Routes>
        <Route path='/' element={<Navigate to={`${authRoute.base}`} />}></Route>

        <Route path='/'>
          {publicRoutes.map((route, index) => {
            const Page = route.component || '';
            return (
              <Route key={index} path={route.path} element={<Page />}>
                {route.children &&
                  route.children.length > 0 &&
                  route.children.map((childRoute, index) => {
                    const ChildComponent = childRoute.component;
                    return (
                      <Route
                        key={index}
                        path={childRoute.path}
                        index={childRoute.index ?? false}
                        element={<ChildComponent />}
                      />
                    );
                  })}
              </Route>
            );
          })}
        </Route>

        <Route element={<ProtectedRoute role={RoleEnum.ADMIN} />}>
          <Route path={adminRoute.base} element={<MainLayout />}>
            {privateAdminRoutes.map((route, index) => {
              const Page = route.component || '';
              return (
                <Route key={index} path={route.path} element={<Page />}>
                  {route.children &&
                    route.children.length > 0 &&
                    route.children.map((childRoute, index) => {
                      const ChildComponent = childRoute.component;
                      return (
                        <Route
                          key={index}
                          path={childRoute.path}
                          index={childRoute.index ?? false}
                          element={<ChildComponent />}
                        />
                      );
                    })}
                </Route>
              );
            })}
          </Route>
        </Route>

        <Route element={<ProtectedRoute role={RoleEnum.STAFF} />}>
          <Route path={staffRoute.base} element={<MainLayout />}>
            {privateStaffRoutes.map((route, index) => {
              const Page = route.component || '';
              return (
                <Route key={index} path={route.path} element={<Page />}>
                  {route.children &&
                    route.children.length > 0 &&
                    route.children.map((childRoute, index) => {
                      const ChildComponent = childRoute.component;
                      return (
                        <Route
                          key={index}
                          path={childRoute.path}
                          index={childRoute.index ?? false}
                          element={<ChildComponent />}
                        />
                      );
                    })}
                </Route>
              );
            })}
          </Route>
        </Route>

        <Route path='*' element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
